(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-slideshow"] && !Shopify.designMode) return;
  try {
    
  class PCarousel {
    constructor(el) {
      this.el       = el;
      this.thumbs   = el.querySelectorAll('.pcarousel__thumb');
      this.images   = el.querySelectorAll('.pcarousel__main-image');
      this.details  = el.querySelectorAll('.pcarousel__details');
      this.current  = 0;
      this.autoplay = el.dataset.autoplay === 'true';
      this.speed    = parseInt(el.dataset.speed, 10) || 5000;
      this.timer    = null;
      this.init();
    }

    init() {
      this.thumbs.forEach(thumb => {
        thumb.addEventListener('click', () => this.go(parseInt(thumb.dataset.index, 10)));
      });

      const prevBtn = this.el.querySelector('.pcarousel__nav--prev');
      const nextBtn = this.el.querySelector('.pcarousel__nav--next');
      if (prevBtn) prevBtn.addEventListener('click', () => this.go((this.current - 1 + this.thumbs.length) % this.thumbs.length));
      if (nextBtn) nextBtn.addEventListener('click', () => this.go((this.current + 1) % this.thumbs.length));

      this.el.addEventListener('mouseenter', () => this.stopAutoplay());
      this.el.addEventListener('mouseleave', () => { if (this.autoplay) this.startAutoplay(); });

      if (this.autoplay && this.thumbs.length > 1) this.startAutoplay();
    }

    go(index) {
      this.current = index;

      this.thumbs.forEach((t, i) => {
        t.classList.toggle('is-active', i === index);
        t.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
      this.images.forEach((img, i)  => img.classList.toggle('is-active', i === index));
      this.details.forEach((d, i)   => d.classList.toggle('is-active', i === index));
    }

    startAutoplay() {
      this.stopAutoplay();
      this.timer = setInterval(() => {
        this.go((this.current + 1) % this.thumbs.length);
      }, this.speed);
    }

    stopAutoplay() { clearInterval(this.timer); }
  }

  document.querySelectorAll('.pcarousel').forEach(el => new PCarousel(el));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
